import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Col, Row } from 'reactstrap';

import SpecialFormattedNumber from 'Components/Utility/Price/SpecialFormattedNumber';

export default function CheckoutModalSummary({
  itemTotal,
  total,
  subtotal,
  saving,
  voucherSaving,
  voucher,
}) {
  return (
    <div className="checkout-modal-summary">
      <div className="summary-box p-3">
        <h6 className="summary-title">
          <FormattedMessage id="checkout-modal-summary.cart-summary" defaultMessage="Cart Summary" />
        </h6>
        <Row className="mb-1">
          <Col xs={7} lg={8}>
            {itemTotal}
            &nbsp;
            {itemTotal > 1 ?
              <span>Items</span>
              :
              <span>Item</span>
            }
          </Col>
          <Col className="text-right pl-0" xs={5} lg={4}>
            {
              /* eslint-disable react/style-prop-object */
              <SpecialFormattedNumber
                value={subtotal}
                style="currency"
              />
            }
          </Col>
        </Row>
        <Row>
          <Col xs={7} lg={8}>
            <FormattedMessage id="checkout-modal-summary.saving" defaultMessage="Saving" />
          </Col>
          <Col className="text-right pl-0" xs={5} lg={4}>
            {
              <SpecialFormattedNumber
                value={0 - saving}
                style="currency"
              />
            }
          </Col>
        </Row>
        {voucherSaving > 0 &&
          <Row>
            <Col xs={7} lg={8}>
              <FormattedMessage id="checkout-modal-summary.coupon" defaultMessage="Coupon:" />
              &nbsp;
              <br />
              <span className="voucher-code">{voucher.name}</span>
            </Col>
            <Col className="text-right pl-0" xs={5} lg={4}>
              {
                <SpecialFormattedNumber
                  value={0 - voucherSaving}
                  style="currency"
                />
              }
            </Col>
          </Row>
        }
        <div className="summary-line" />
        <Row className="summary-total">
          <Col>
            <FormattedMessage id="checkout-modal-summary.total" defaultMessage="TOTAL" />
          </Col>
          <Col className="text-right pl-0">
            {
              <SpecialFormattedNumber
                value={total}
                style="currency"
              />
            }
          </Col>
        </Row>
      </div>
    </div>
  );
}

CheckoutModalSummary.propTypes = {
  itemTotal: PropTypes.number,
  total: PropTypes.number,
  subtotal: PropTypes.number,
  saving: PropTypes.number,
  voucherSaving: PropTypes.number,
  voucher: PropTypes.shape({}),
};

CheckoutModalSummary.defaultProps = {
  itemTotal: 0,
  total: 0,
  subtotal: 0,
  saving: 0,
  voucherSaving: 0,
  voucher: null,
};
